import React from 'react'
import { Link, Text } from '@sketch/components'
import {
  Description,
  FootNote,
  QuestionMarkIcon,
  Section,
  Title,
  Divider,
} from './WorkspaceSettingsIntegrations.styles'
import { SKETCH_WEBSITE } from '@sketch/env-config'
import { WorkspaceIntegrations } from '../../components/WorkspaceIntegrations'
import { useIntegrationErrorHandler } from '../../hooks'

export interface WorkspaceSettingsIntegrationsProps {
  workspaceId: string
}

export const WorkspaceSettingsIntegrations: React.FC<
  WorkspaceSettingsIntegrationsProps
> = ({ workspaceId }) => {
  useIntegrationErrorHandler()

  return (
    <Section>
      <Title>Integrations</Title>
      <Description>
        Integrations connect your workspace directly to the external apps and
        services your members already rely on.{' '}
        <Link href={`${SKETCH_WEBSITE}/redirect/web/integrations`} external>
          Learn More ↗
        </Link>
      </Description>

      <WorkspaceIntegrations workspaceId={workspaceId} />
      <Divider />

      <FootNote>
        <div>
          <QuestionMarkIcon />
        </div>
        <Text textStyle="copy.tertiary.standard.D">
          <strong>
            Missing an integration?{' '}
            <Link href="https://www.sketch.com/support/contact/" external>
              Reach out
            </Link>
          </strong>{' '}
          and let us know if you’d like to integrated Sketch with other
          services.
        </Text>
      </FootNote>
    </Section>
  )
}
